import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';
import { Loading } from '~/components/Loading';

export const Route = createFileRoute('/_auth/_appLayout/integrations')({
  component: RouteComponent,
  pendingComponent: () => <Loading />,
  errorComponent: NestedRouteErrorBoundary,
});

function RouteComponent() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/' });
  }, [navigate]);

  return null;
}
